
import Header from './Header';
import AboutSection from './AboutSection';
import ProjectsSection from './ProjectsSection';
import ContactSection from './ContactSection';
import MainLayout from "./admin/MainLayout";

function Home() {
  return (

    <MainLayout>
      <Header />
      <AboutSection />
      <ProjectsSection />
      <ContactSection />

    </MainLayout>
  );
}

export default Home;